/**
 * BatchFormHeader - Header and discount banner for batch forms
 */

import { Sparkles, Percent, Clock } from 'lucide-react';

interface BatchHeaderProps {
  discount: number;
}

export function BatchHeader({ discount }: BatchHeaderProps) {
  return (
    <div>
      <h2 className="flex items-center gap-2 text-xl font-semibold text-neutral-900 dark:text-neutral-100">
        <Sparkles className="h-6 w-6 text-orange-500" />
        Batch Generierung
      </h2>
      <p className="mt-1 text-sm text-neutral-500">
        Generiere mehrere Bilder gleichzeitig mit {discount}% Rabatt
      </p>
    </div>
  );
}

interface DiscountBannerProps {
  discount: number;
}

export function DiscountBanner({ discount }: DiscountBannerProps) {
  return (
    <div className="p-4 rounded-lg bg-gradient-to-r from-orange-500/10 to-amber-500/10 border border-orange-200 dark:border-orange-800">
      <div className="flex items-center gap-3">
        <Percent className="h-5 w-5 text-orange-500" />
        <div>
          <span className="font-medium text-orange-700 dark:text-orange-300">
            {discount}% Batch-Rabatt
          </span>
          <span className="mx-2 text-neutral-400">|</span>
          <span className="text-sm text-neutral-600 dark:text-neutral-400">
            <Clock className="h-4 w-4 inline mr-1" />
            Verarbeitung bis zu 24 Stunden
          </span>
        </div>
      </div>
    </div>
  );
}
